import { Spacing } from '@persona-id/design-tokens';
import { EyeIcon, EyeOffIcon } from '@persona-id/design-tokens/icons';
import { SyntheticEvent, useState } from 'react';
import styled from 'styled-components';

export const SsnMasker = ({ ssn }: { ssn: string }) => {
  const [hidden, setHidden] = useState(true);

  const toggleIcon = (event: SyntheticEvent) => {
    event.stopPropagation();
    setHidden(!hidden);
  };

  const bullets = Array(ssn.length).fill('•').join('');

  return hidden ? (
    <SsnContainer>
      {dashify(bullets)}
      <EyeOffIcon
        id='ssn-masker__icon-off'
        aria-label='Show SSN'
        role='button'
        style={{ cursor: 'pointer' }}
        onClick={toggleIcon}
      />
    </SsnContainer>
  ) : (
    <SsnContainer>
      {ssn && dashify(ssn)}
      <EyeIcon
        id='ssn-masker__icon-on'
        aria-label='Hide SSN'
        role='button'
        style={{ cursor: 'pointer' }}
        onClick={toggleIcon}
      />
    </SsnContainer>
  );
};

const dashify = (value: string) =>
  value.length === 9 ? `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5, 9)}` : value;

const SsnContainer = styled.span`
  display: flex;
  grid-gap: ${Spacing[1]};
  align-items: center;
`;
